import type { Metric } from "./types";
const number = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 });
export function metricValue(metric: Metric | undefined): string {
  if (!metric || metric.value === null || !Number.isFinite(metric.value))
    return "—";
  return metric.unit === "percent"
    ? `${number.format(metric.value * 100)}%`
    : number.format(metric.value);
}
export function metricChange(metric: Metric | undefined): string {
  if (
    !metric ||
    metric.comparison_available !== true ||
    metric.quality !== "exact" ||
    metric.value === null ||
    metric.previous === null
  )
    return "Comparison unavailable";
  if (metric.unit === "count" && metric.previous === 0)
    return metric.value > 0 ? "New" : "No change";
  if (metric.change === null) return "Comparison unavailable";
  if (metric.change === 0) return "No change";
  return `${metric.change > 0 ? "+" : ""}${number.format(metric.change)}${metric.unit === "percent" ? " pp" : metric.unit === "position" ? " positions" : "%"}`;
}
export function cellValue(value: unknown, key: string): string {
  if (value === null || value === undefined) return "—";
  if (typeof value === "number")
    return key === "ctr"
      ? `${number.format(value * 100)}%`
      : key === "click_change"
        ? `${value > 0 ? "+" : ""}${number.format(value)}%`
        : number.format(value);
  return String(value);
}
export function errorMessage(error: unknown): string {
  const status = (error as { status?: number })?.status;
  if (status === 403)
    return "You do not have permission to do this. Ask a workspace owner for access.";
  if (status === 404)
    return "This website or report is no longer available in this workspace.";
  if (status === 409)
    return "The connection changed or a refresh is already in progress. Reload the latest details and try again.";
  if (status === 429)
    return "The request limit was reached. Wait a little before trying again.";
  return error instanceof Error
    ? error.message
    : "Something went wrong. Please try again.";
}
export function safePageUrl(value: string): string | undefined {
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) &&
      !url.username &&
      !url.password
      ? url.href
      : undefined;
  } catch {
    return undefined;
  }
}
